import Redactor from './component'

export default Vue => {
  Vue.component('text-editor', Redactor)
}
